import React from 'react';
import TextField from '@mui/material/TextField';
import { useBookingContext } from '../../../../hooks/use-booking-context';

const DecimalTextField = ({ serviceFee, setServiceFee }) => {
  const { numberFormatter, allowedCharsRegex } = useBookingContext();
  const zeroValue = numberFormatter.format(0);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    if (parseFloat(newValue) <= 500) {
      setServiceFee(newValue.replace(allowedCharsRegex, ''));
    } else if (newValue === zeroValue || newValue === '') {
      setServiceFee(zeroValue);
    }
  };

  const handleBlur = () => {
    const numericValue = parseFloat(serviceFee) || 0;
    setServiceFee(numberFormatter.format(numericValue));
  };

  return (
    <TextField
      value={serviceFee}
      onChange={handleChange}
      onBlur={handleBlur}
      inputProps={{
        style: {
          width: '90px',
          height: '31px',
          padding: '4px',
          lineHeight: '23.4px',
          fontSize: '18px',
          textAlign: 'right',
          backgroundColor: '#FFFFFF',
        },
      }}
    />
  );
};

export default DecimalTextField;
